import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "plus2",
  "use": "plus2-usage",
  "viewBox": "0 0 500 500",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 500 500\" id=\"plus2\">\n  <polygon fill=\"currentColor\" points=\"400 166.667 233.333 166.667 233.333 0 166.667 0 166.667 166.667 0 166.667 0 233.333 166.667 233.333 166.667 400 233.333 400 233.333 233.333 400 233.333\" transform=\"translate(54 53)\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol